// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../addWeeks/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var addWeeks = convertToFP(fn, 2);
export default addWeeks;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/addWeeks/index.js
// module id = 818
// module chunks = 0